import React, { Component } from 'react'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import { withStyles } from '@material-ui/core/styles'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import { connect } from 'react-redux'
import InputGroup from '../../../../../components/UI/Forms/InputGroup/InputGroup'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit'
import SaveIcon from '@material-ui/icons/Save'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import Modal from '../../../../../components/UI/Modal/Modal'
import * as actions from '../../../../../store/actions/index'
import Footer from '../../../../../components/UI/Modal/Footer/Footer'
import Aux from '../../../../../hoc/Auxiliary/Auxiliary'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
// import classes from './weightTable.scss'
// import Box from '@material-ui/core/Box'
// import Collapse from '@material-ui/core/Collapse'
class SpanningTable extends Component {
  state = {
    test: true,
    editttt: false,
    level_structures: [],
    valid: true,
    openToggle: false,
    anchorEl: null,
    modalOpen: false,
    structure: '',
    selectLevel: '',
    selectStruc: '',
    kpi: [],
    competency: []
  }

  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    if (props.weightAll && state.level_structures.length === 0) {
      let level_structures = props.weightAll.map(item => {
        return {
          level_group_id: item.level_group_id,
          structure_id: item.structure_id,
          weight_percent: item.weight_percent,
          assessor_group_criteria: item.assessor_group_criteria,
          kpi: item.kpi,
          competency: item.competency,
          kpi_criteria: item.kpi_criteria,
          competency_criteria: item.competency_criteria
        }
      })
      updatedState = {
        ...updatedState,
        level_structures: level_structures
      }
    } else {
      if (!props.selected && state.level_structures.length === 0) {
        let level_structures = []
        props.data.row.data.map(row =>
          level_structures.push(
            ...props.data.col.data.map(col => {
              let val = {
                level_group_id: row.level_group_id,
                structure_id: col.structure_id,
                weight_percent: 0,
                assessor_group_criteria: []
              }
              return val
            })
          )
        )

        updatedState = {
          ...updatedState,
          level_structures: level_structures
        }
      }
      if (
        props.selected &&
        props.selected?.level_structures !== state.level_structures &&
        state.level_structures.length === 0
      ) {
        //////////////ALL//////////////////////
        let level_structures = []
        props.data.row.data.map(row =>
          level_structures.push(
            ...props.data.col.data.map(col => {
              let val = {
                level_group_id: row.level_group_id,
                structure_id: col.structure_id,
                weight_percent: 0,
                assessor_group_criteria: []
              }
              return val
            })
          )
        )
        //////////////ALL//////////////////////

        let t = props.selected.level_structures.map(item => {
          let ass = item.assessor_group_criteria.map(cs => {
            let casee = -1
            let addcase = []
            let leve = cs.level_position_group.map(le => {
              return le
            })

            leve.map(ve => {
              if (ve.case_id !== casee) {
                addcase.push({ case_id: ve.case_id, value: [ve] })
                casee = ve.case_id
              } else {
                if (addcase[ve.case_id]?.value) {
                  addcase[ve.case_id].value.push(ve)
                } else if (addcase[ve.case_id - 1]?.value) {
                  addcase[ve.case_id - 1].value.push(ve)
                } else if (addcase[addcase.length - 1]?.value) {
                  addcase[addcase.length - 1].value.push(ve)
                }
              }
              return ve
            })

            return {
              assessor_group_id: cs.assessor_group_id,
              weight_percent: cs.weight_percent,
              level_position_group: addcase
            }
          })

          return {
            level_group_id: item.level_group_id,
            structure_id: item.structure_id,
            weight_percent: item.weight_percent,
            assessor_group_criteria: ass,
            kpi: item.kpi,
            competency: item.competency,
            kpi_criteria: item.kpi_criteria,
            competency_criteria: item.competency_criteria
          }
        })

        level_structures = level_structures.map(old => {
          let a = t.find(
            neww =>
              neww.level_group_id === old.level_group_id && neww.structure_id === old.structure_id
          )
          if (a) {
            return a
          } else {
            return old
          }
        })

        //////////////Select//////////////////////
        // level_structures = props.selected.level_structures.map(item => {
        //   // let structure =
        //   return {
        //     level_group_id: item.level_group_id,
        //     structure_id: item.structure_id,
        //     weight_percent: item.weight_percent,
        //     assessor_group_criteria: item.assessor_group_criteria
        //   }
        // })
        //////////////Select//////////////////////
        props.saveAllTable(level_structures)
        updatedState = {
          ...updatedState,
          level_structures: level_structures
        }
      }
    }

    return updatedState
  }

  editTable = () => {
    let edit = this.state.edit
    this.props.edit(edit)
    this.setState({
      edit: !edit
    })
  }
  inputModalChanged = (type, id, e) => {
    if (+e.target.value || e.target.value.length === 0) {
      if (type === 'kpi') {
        let kpi = this.state.kpi
        // let competency = this.state.competency
        let check = true
        kpi = kpi.map(item => {
          if (item.level_group_id === id) {
            check = false
            return {
              level_group_id: id,
              weight_percent: e.target.value
            }
          }
          return item
        })

        if (check) {
          kpi.push({ level_group_id: id, weight_percent: e.target.value })
        }
        kpi = kpi.filter(item => item.weight_percent !== '')
        let checkPercent = 0
        kpi.map(item => {
          checkPercent = checkPercent + +item.weight_percent
          return item
        })
        this.setState({
          kpi: kpi,
          validatePer: checkPercent === +this.state.maxPercent || checkPercent === 0
        })
      }
      if (type === 'competency') {
        let competency = this.state.competency
        let check = true
        competency = competency.map(item => {
          if (item.competency_type_id === id) {
            check = false
            return {
              competency_type_id: id,
              weight_percent: e.target.value
            }
          }
          return item
        })
        if (check) {
          competency.push({ competency_type_id: id, weight_percent: e.target.value })
        }
        competency = competency.filter(item => item.weight_percent !== '')
        let checkPercent = 0
        competency.map(item => {
          checkPercent = checkPercent + +item.weight_percent
          return item
        })
        this.setState({
          competency: competency,
          validatePer: checkPercent === +this.state.maxPercent || checkPercent === 0
        })
      }
    }
  }
  inputChanged = (col, row, e) => {
    let level_structures = this.state.level_structures

    let check = level_structures.find(item => {
      return +item.structure_id === +col && +item.level_group_id === +row
    })
    let updateLevelStr = {}
    if (check) {
      updateLevelStr = level_structures.map(item => {
        if (item.structure_id === col && item.level_group_id === row) {
          return {
            ...item,
            weight_percent: parseInt(e.target.value) || 0
          }
        } else return item
      })
    } else {
      let item = {
        level_group_id: row,
        structure_id: col,
        weight_percent: parseInt(e.target.value) || 0,
        assessor_group_criteria: []
      }
      updateLevelStr = level_structures
      updateLevelStr.push(item)
    }
    this.props.weigthChanged(updateLevelStr)

    this.setState({
      level_structures: updateLevelStr
    })
  }

  checkValue = (col, row) => {
    let check = this.state.level_structures.find(
      item => item.structure_id === col && item.level_group_id === row
    )

    // if(this.state.edit){
    //   this.checkWeight()
    // }

    if (check) {
      return parseInt(check.weight_percent) || 0
    } else {
      return 0
    }
  }

  checkWeight = () => {
    let valid = true
    if (this.state.edit) {
      let weight = 0
      let level = 0
      weight = 0
      this.state.level_structures.map(item => {
        if (level !== item.level_group_id) {
          if (weight === 100 || weight === 0) {
            valid = valid && true
          } else {
            valid = valid && false
          }
          weight = 0
          weight = weight + (parseInt(item.weight_percent) || 0)
          level = item.level_group_id
        } else {
          weight = weight + (parseInt(item.weight_percent) || 0)
        }
        return item
      })
      if (weight === 100 || weight === 0) {
        valid = valid && true
      } else {
        valid = valid && false
      }

      // this.setState({
      //   valid: valid
      // })

      return !valid
    }
  }

  checkDisable = val => {
    if (parseInt(val) === 0) {
      return true
    } else {
      return false
    }
  }

  modalSubmitHandler = () => {
    let level_structures = this.props.weightAll.map(item => {
      if (
        item.level_group_id === this.state.selectLevel &&
        item.structure_id === this.state.selectStruc
      ) {
        return {
          ...item,
          kpi: this.state.kpi,
          kpi_criteria: this.state.kpi,
          competency: this.state.competency,
          competency_criteria: this.state.competency
        }
      } else {
        return item
      }
    })

    this.props.weigthChanged(level_structures)
    this.setState({
      modalOpen: false
    })
  }
  checkModalValue = (type, id) => {
    if (type === 'kpi') {
      let select = this.state.kpi.find(item => item.level_group_id === id)
      if (select) {
        return select.weight_percent
      } else {
        return ''
      }
    }
    if (type === 'competency') {
      let select = this.state.competency.find(item => item.competency_type_id === id)
      if (select) {
        return select.weight_percent
      } else {
        return ''
      }
    }
  }
  handlemodalOpen = (structure, selectLevel, selectStruc, value) => {
    let select = this.props.weightAll.find(
      item => item.level_group_id === selectLevel && item.structure_id === selectStruc
    )
    let kpi = []
    let competency = []
    let checkPer = 0
    if (select) {
      if (select?.kpi_criteria) {
        kpi = select.kpi_criteria.map(item => {
          checkPer = checkPer + +item.weight_percent
          return {
            level_group_id: item.level_group_id,
            weight_percent: item.weight_percent
          }
        })
      }
      if (select?.competency_criteria) {
        competency = select.competency_criteria.map(item => {
          checkPer = checkPer + +item.weight_percent
          return {
            competency_type_id: item.competency_type_id,
            weight_percent: item.weight_percent
          }
        })
      }
    }
    this.setState({
      modalOpen: true,
      kpi: kpi,
      competency: competency,
      structure: structure,
      selectLevel: selectLevel,
      selectStruc: selectStruc,
      maxPercent: +value,
      validatePer: checkPer === +value || checkPer === 0
    })
  }
  render() {
    const StyledTableCell = withStyles(theme => ({
      head: {
        backgroundColor: '#3d6bb3',
        color: theme.palette.common.white,
        borderLeft: '1px solid rgba(224, 224, 224, 1)'
      },
      body: {
        fontSize: 14
      }
    }))(TableCell)
    const buttonGroups = (
      <Footer
        save={() => this.modalSubmitHandler()}
        // another={() => this.formSubmitHandler('saveAno')}
        showAnother={false}
        cancel={() => this.setState({ modalOpen: false })}
        disable={!(this.state.validatePer || this.state.structure === 'STT01')}
      />
    )
    return (
      <div>
        {/* <div>
          <Button onClick={this.editTable} variant='contained' disabled={this.checkWeight()}>
            {this.state.edit ? 'Save' : 'Edit'}
          </Button>
        </div> */}
        <TableContainer component={Paper}>
          <Table aria-label='spanning table'>
            <TableHead>
              <TableRow>
                <StyledTableCell align='center' rowSpan={2}>
                  {this.props.data.row.label}
                </StyledTableCell>
                <StyledTableCell align='center' colSpan={this.props.data.col.data.length}>
                  {/* <Grid container justify={'space-between'}>
                    <Grid item xs={1}>
                      {this.props.data.col.label}
                    </Grid>
                    <Grid item xs={1}>
                      <Button
                        onClick={this.editTable}
                        variant='contained'
                        disabled={this.checkWeight()}>
                        {this.state.edit ? 'Save' : 'Edit'}
                      </Button>
                      <IconButton size='small' onClick={() => this.editTable}>
                        <EditIcon fontSize='inherit' />
                      </IconButton>
                    </Grid>
                  </Grid> */}
                  <Grid container justify={'space-between'}>
                    <Grid item xs={11}>
                      {this.props.data.col.label}
                    </Grid>
                    <Grid item xs={1}>
                      <IconButton onClick={() => this.editTable()} disabled={this.checkWeight()}>
                        {this.state.edit ? (
                          <SaveIcon
                            style={{ color: this.checkWeight() ? 'gray' : 'white' }}
                            fontSize='inherit'
                          />
                        ) : (
                          <EditIcon style={{ color: 'white' }} fontSize='inherit' />
                        )}
                      </IconButton>
                    </Grid>
                  </Grid>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                {/* <StyledTableCell align='center'>{this.props.data.row.label}</StyledTableCell> */}
                {this.props.data.col.data.map(col => (
                  <StyledTableCell align='center' key={col.structure_id}>
                    {col.structure_name}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {this.checkWeight() ? (
                <TableRow>
                  <TableCell
                    align='center'
                    colSpan={this.props.data.col.data.length + 1}
                    style={{ color: 'red' }}>
                    {this.props.translate('totalWeightValidationHelperText')}
                  </TableCell>
                </TableRow>
              ) : null}

              {this.props.data.row.data.map(row => (
                <React.Fragment>
                  <TableRow key={row.level_group_name}>
                    <TableCell align='left'>{row.level_group_name}</TableCell>
                    {this.props.data.col.data.map(col => (
                      <TableCell align='center' key={col.structure_id}>
                        {this.state.edit ? (
                          <InputGroup
                            key={col.structure_id}
                            inputType={'input'}
                            configs={{
                              inputProps: {
                                style: { textAlign: 'right' }
                              }
                            }}
                            changed={e =>
                              this.inputChanged(col.structure_id, row.level_group_id, e)
                            }
                            inputValue={this.checkValue(col.structure_id, row.level_group_id)}
                          />
                        ) : (
                          <div>
                            <Button
                              variant='outlined'
                              color='primary'
                              disabled={this.checkDisable(
                                this.checkValue(col.structure_id, row.level_group_id)
                              )}
                              onClick={() =>
                                this.props.handleNext(
                                  col.structure_id,
                                  row.level_group_id,
                                  this.state.level_structures
                                )
                              }>
                              {this.checkValue(col.structure_id, row.level_group_id)}
                            </Button>
                            {col.structure_type.value_list_code === 'STT05' ||
                            col.structure_type.value_list_code === 'STT01' ? (
                              <IconButton
                                size='small'
                                disabled={this.checkDisable(
                                  this.checkValue(col.structure_id, row.level_group_id)
                                )}
                                onClick={
                                  () =>
                                    this.handlemodalOpen(
                                      col.structure_type.value_list_code,
                                      row.level_group_id,
                                      col.structure_id,
                                      this.checkValue(col.structure_id, row.level_group_id)
                                    )
                                  // this.setState({
                                  //   modalOpen: true,
                                  //   structure: col.structure_type.value_list_code,
                                  //   selectLevel: row.level_group_id,
                                  //   selectStruc: col.structure_id
                                  // })
                                }>
                                <MoreVertIcon />
                              </IconButton>
                            ) : null}
                          </div>
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Modal
          open={this.state.modalOpen}
          onHide={() => this.setState({ modalOpen: false })}
          header={`${this.props.translate(
            this.state.structure === 'STT01' ? 'kpi' : 'competency'
          )} ${this.props.translate('criteria')}`}
          disableBackdropClick={true}
          footer={buttonGroups}>
          <TableContainer component={Paper}>
            <Table aria-label='spanning table'>
              <TableHead>
                <TableRow>
                  <StyledTableCell align='center'>
                    {this.state.structure === 'STT01'
                      ? this.props.translate('organizationLevel')
                      : this.props.translate('competencyType')}
                  </StyledTableCell>
                  <StyledTableCell align='center'>%</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!this.state.validatePer && this.state.structure !== 'STT01' ? (
                  <TableRow>
                    <TableCell style={{ color: 'red' }} colSpan={2} align='center'>
                      {this.props.translate('totalValidation')}
                      {this.state.maxPercent}%
                    </TableCell>
                  </TableRow>
                ) : null}
                {this.state.structure === 'STT01'
                  ? this.props.levelTable.kpi_criteria.map(item => (
                      <Aux>
                        <TableRow>
                          <TableCell align='center'>{item.level_group_name}</TableCell>
                          <TableCell align='center'>
                            <InputGroup
                              inputType={'input'}
                              configs={{
                                inputProps: {
                                  style: { textAlign: 'right' }
                                }
                              }}
                              changed={e => this.inputModalChanged('kpi', item.level_group_id, e)}
                              inputValue={this.checkModalValue('kpi', item.level_group_id)}
                            />
                          </TableCell>
                        </TableRow>
                      </Aux>
                    ))
                  : this.props.levelTable.competency_criteria.map(item => (
                      <Aux>
                        <TableRow>
                          <TableCell align='center'>{item.value_list_name}</TableCell>
                          <TableCell align='center'>
                            <InputGroup
                              inputType={'input'}
                              configs={{
                                inputProps: {
                                  style: { textAlign: 'right' }
                                }
                              }}
                              changed={e =>
                                this.inputModalChanged('competency', item.value_list_id, e)
                              }
                              inputValue={this.checkModalValue('competency', item.value_list_id)}
                            />
                          </TableCell>
                        </TableRow>
                      </Aux>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    levelTable: state.criteria.levelTable,
    loading: state.criteria.loading
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchLevelTableOptions: recordId => dispatch(actions.fetchLevelTable(recordId))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(SpanningTable))
